/**
 * SHARED
 * Cross-cutting code usable by any module. Must not import from any module.
 *
 * Route guard for the customer System Settings area. Only workspace owners /
 * admins may manage company setup; everyone else is redirected home silently.
 * (RLS remains the hard boundary — this only hides the UI.)
 */

import { Navigate } from "react-router-dom";
import { useWorkspaceAdmin } from "../hooks/useWorkspaceAdmin.js";

export default function RequireWorkspaceAdmin({ children }) {
  const { isWorkspaceAdmin, checked } = useWorkspaceAdmin();
  if (!checked) return null; // brief: still resolving the workspace role
  if (!isWorkspaceAdmin) return <Navigate to="/" replace />;
  return children;
}
